import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/ListFilter.css';
import FX from './functions/functions';
class ListFilter extends Component {
  constructor(props){
    super(props);
    this.state = {show:false};
  }
  toggle = () => {
    this.setState({show:!this.state.show});
  }
  optionToggle = (tgt_filter, value) => {
    var filter = this.props.list.state.filter;
    console.log(filter);
    this.props.list.state.filter.forEach(fil => {
      if(fil.name === tgt_filter){
        var rem
        if (fil.type === 'switch' && fil.active.indexOf(value) >= 0){
          fil.active= [];
        }
        else if(fil.type === 'switch'){
          fil.active= [value];
        }
        else if((rem = fil.active.indexOf(value)) >= 0){
          fil.active.splice(rem, 1);
        }
        else {
          fil.active.push(value);
        }
      }
    });
    this.props.list.setState({filter: filter});

    if (typeof this.props.filterAction === 'function'){
      this.props.filterAction(filter);
    }


  }
  clearFilter = (tgt_filter) => {
    var filter = this.props.list.state.filter;
    this.props.list.state.filter.forEach(fil => {
      if(fil.name === tgt_filter){
        fil.active = [];
      }
    });
    this.props.list.setState({filter: filter});
    if (typeof this.props.filterAction === 'function'){
      this.props.filterAction(filter);
    }
  }
  hide = () => {
    this.setState({show:false});
  }
  render() {
    console.log(this.props)
    var current_customer = this.props.root.state.current_customer;
    var vis = 'ListFilter';
    if(this.state.show){
      vis += ' show';
    }
    if(this.props.className){
      vis += ' ' + this.props.className;
    }
    var items = this.props.model.filter.map((filter,i) => {
      var options = [];
      if(filter.options){
        if(typeof filter.options === 'string'){
         if(current_customer[filter.options]){
           options = current_customer[filter.options];
         }
        }
        else if( Array.isArray( filter.options )){
          options = filter.options;
        }
        options = options.map((opt, j)=>{
          var className = "FilterOption";
          filter.active.some((active) => {
            if(parseInt(opt.id,10) === parseInt(active,10))  {
              className = "FilterOption active"
              return true;
            }
            return false;
          });
          return <div key={j} onClick={this.optionToggle.bind(this,filter.name, opt.id)} className={className}>{opt[filter.titleField]}</div>
        });
      }
      var unselected = 'FilterOption';
      if(filter.active.length===0){
        unselected = 'FilterOption active';
      }
      return (
      <div className="FilterOptions" key={i}>
        <div className="title">{filter.title}</div>
        <div className={unselected} onClick={this.clearFilter.bind(this,filter.name)}>{filter.offTitle}</div>
        <div className="options">
        {options}
        </div>
      </div>);
    });
    return (
      <div className={vis}>
        <div className="btnLand" onClick={this.toggle}>Filter List</div>
        <div className="Modal" onClick={this.toggle}>
          <div className="Options" id="Options" onClick={FX.defend}>
            <div className="ModalClose" onClick={this.toggle}>X</div>
            <div className="filter">
              {items}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ListFilter;



// WEBPACK FOOTER //
// ./src/ListFilter.js